import { render, staticRenderFns } from "./new-materials.vue?vue&type=template&id=a9457924"
import script from "./new-materials.vue?vue&type=script&lang=js"
export * from "./new-materials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports